import { actions as notyActions } from 'layouts/ErrorBox'
import { loadingActions } from 'store/loader'

export const generateNotyMessage = (message, success = true, icon) => {
  const defaultIcon = success ? 'far fa-check-circle' : 'far fa-times-circle'
  const notyIcon = icon || defaultIcon
  return `<div class='flexed centered-aligned' ><i class="first ${notyIcon}"></i><span>${message}</span></div><span>Clear</span>`
}

const _defaultMessages = {
  '500':
    'The server is experiencing technical difficulties. Please try again later.',
  '401': 'Authorization required, please login to continue.',
  '403': 'Consent required, please login and consent to continue.',
  '404': 'Page or resource not found.',
}

// default fail behavior is to display _defaultMessages
// customFail will replace all default behavior
const _defaultFail = (
  response,
  resContent,
  customFail,
  failMessage,
  skipNotyFail,
) => {
  const content = JSON.parse(resContent)
  let errMessage = failMessage || _defaultMessages[response.status]
  errMessage =
    errMessage ||
    content.message ||
    `${response.status} Error: ${response.statusText}.`
  return dispatch => {
    if (response.status === 401) {
      dispatch(
        notyActions.showError({
          text: _defaultMessages['401'],
          timeout: 5000,
          killer: true,
        }),
      )
    }
    if (customFail) {
      dispatch(customFail(response, content.message))
    } else if (!skipNotyFail) {
      dispatch(notyActions.showError({ text: errMessage, timeout: 2000 }))
    }
  }
}

// default success behavior
const _getDefaultSuccess = successMessage => {
  // return () => {
  //   return dispatch => {
  //     if (successMessage)
  //       dispatch(notyActions.showSuccess({ text: successMessage }))
  //   }
  // }
}

const request = ({
  method = 'GET',
  url,
  body,
  headerOptions,
  contentType = 'application/json',
  success,
  skipNotySuccess,
  skipNotyFail = false,
  fail,
  failMessage,
  successMessage,
  catchMessage,
  forceLoader = false,
  authRequired = true,
  resType = 'json', // currently supports only blob or json responses
  hasLoader = false,
  noAuthField = false,
  noContentType = false,
}) => {
  return (dispatch, getState) => {
    if (hasLoader) dispatch(loadingActions.startLoader(forceLoader))
    const resolveLoader = () => {
      if (hasLoader) dispatch(loadingActions.stopLoader(forceLoader))
    }
    const { user } = getState()

    let isZip = false
    const callback = () => {
      // track response
      let response

      // establish default success behavior (print success message if provided)
      success = success || _getDefaultSuccess(successMessage)

      // setup headers
      const headers = {
        Authorization: null,
      }
      if (contentType) headers['Content-Type'] = contentType
      Object.assign(headers, headerOptions)

      if (contentType === 'multipart/form-data' || noContentType) {
        delete headers['Content-Type']
      }

      if (noAuthField) delete headers.Authorization

      // make fetch request
      return fetch(url, { method, headers, body })
        .then(res => {
          response = res
          if (res.ok) {
            if (res.url.includes('.zip')) isZip = true
            if (!isZip) {
              if (resType === 'json') return res.json()
              if (resType === 'blob') return res.blob()
            }
            return Promise.resolve(res.blob())
          }
          return res.text()
        })
        .then(resContent => {
          let nextStep
          if (response.ok) {
            if (!skipNotySuccess && successMessage)
              dispatch(
                notyActions.showSuccess({
                  text: successMessage,
                  timeout: 2000,
                }),
              )
            nextStep = success(resContent)
          } else {
            nextStep = dispatch(
              _defaultFail(
                response,
                resContent,
                fail,
                failMessage,
                skipNotyFail,
              ),
            )
          }
          resolveLoader()
          return nextStep || true // return default true to handle conditional promise chaining
        })
        .catch(err => {
          if (catchMessage)
            dispatch(
              notyActions.showError({ text: catchMessage, timeout: 2000 }),
            )
          resolveLoader()
          console.log(err)
        })
    }
    if (!authRequired) return callback()
    return validateSession(dispatch, user, callback)
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js